
export const DEVICE_DEPLOYED = 'deployed';
export const DEVICE_NOT_DEPLOYED = 'not_deployed';
export const DEVICE_FILTERED = 'filtered';
export const DEVICE_BLACK_LIST = 'black';
export const DEVICE_WHITE_LIST = 'white';
